import React from 'react';

import {SegmentedControl} from '@albert-io/atomic';

import {TO_DO_PROXIMITY} from './getFilters';
import type {AssignmentFilter} from './StudentAssignment.types';

interface FilterOption {
  label: string;
  value: AssignmentFilter;
}

const OPTIONS: FilterOption[] = [
  {label: 'To Do', value: 'toDo'},
  {label: 'Open', value: 'open'},
  {label: 'Closed', value: 'closed'}
];

const CLASS_OPTIONS: FilterOption[] = [{label: 'All', value: 'all'}, ...OPTIONS];

export const FILTER_DESCRIPTIONS: Record<Exclude<AssignmentFilter, 'all'>, string> = {
  toDo: `Open assignments due within the next ${TO_DO_PROXIMITY} days.`,
  open: 'Assignments you can submit, including past due.',
  closed: 'Assignments you’ve submitted or can no longer submit.'
};

interface Props {
  isScopedToClassroom: boolean;
  onChange: (filter: AssignmentFilter) => void;
  value: AssignmentFilter;
}

export default function FilterControl({isScopedToClassroom, onChange, value}: Props) {
  'use memo';

  const options = isScopedToClassroom ? CLASS_OPTIONS : OPTIONS;

  return (
    <SegmentedControl
      ariaLabel='Filter assignments'
      buttonClassName='font-normal'
      onSelect={(selected) => {
        const option = options.find((candidate) => candidate.value === selected);
        if (option && option.value !== value) {
          onChange(option.value);
        }
      }}
      options={options}
      selectedIdx={options.findIndex((option) => option.value === value)}
    />
  );
}
